export const FRAMEWORKS = [
  'react',
  'react-rsuite5',
  'react-material-ui',
  'react-bootstrap',
  'react-antd',
  'react-mantine'
];